import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const KAWAMATA_PHOTO = "/images/assets/frw4e7ao-grS-16195592.jpg";

export default function LeadershipPage() {
  const leaders = [
    {
      id: "kawamata",
      name: "川俣 貴裕",
      nameEn: "Takahiro Kawamata",
      title: "代表取締役",
      bio: "Webマーケティング会社でのSEO実務を経て、2017年にアクセンチュア株式会社に入社。テクノロジーコンサルティング本部にてPMOやCTO支援に従事する。2019年に株式会社IT&Pluckticeを創業。創業期に自社Webメディアを月商100万円規模へ成長させたのち、2021年にはライターのマッチング課題を解決すべく、現在の主事業である「ミライトマッチ」を立ち上げる。現在は4,000名以上のフリーランスと600社以上の発注企業を繋ぎ、さらなる事業拡大と新規事業の開発を推進している。",
      belief: "お役立ちの総量を最大化する",
      showCeoLink: false,
      photo: KAWAMATA_PHOTO,
      photoSize: "w-56",
    },
    {
      id: "watanabe",
      name: "渡邉 有哉",
      nameEn: "Yuya Watanabe",
      title: "取締役",
      bio: "大学時代より株式会社IT&Pluckticeのインターンとして「ミライトマッチ」事業の立ち上げに参画。新卒で株式会社CINCに入社し、SEOコンサルタント・アナリストとして従事。並行して個人で運用するSNSを総フォロワー13万人まで成長させる。株式会社DotHomesにて宿泊事業向けのデジタルマーケティングコンサルを経験したのち、株式会社バズマッチを創業。現在は同社代表を務めるとともに、株式会社IT&Pluckticeの取締役を兼任。",
      belief: "為せば成る、為さねば成らぬ何事も、成らぬは人の為さぬなりけり",
      showCeoLink: false,
      photo: "/images/assets/elpyifel-yuya.png",
      photoSize: "w-44",
    },
  ];

  return (
    <div className="pt-16 md:pt-20 min-h-screen bg-white" data-testid="leadership-page">
      {/* Back Link */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors duration-200"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Home</span>
        </Link>
      </div>

      {/* Header */}
      <section className="py-12 md:py-20 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h1 className="font-en text-4xl md:text-5xl font-bold text-gray-900">
            Leadership
          </h1>
        </div>
      </section>

      {/* Leaders */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div>
            {leaders.map((leader, index) => (
              <div
                key={leader.id}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-12 items-start ${
                  index % 2 === 1 ? "lg:flex-row-reverse" : ""
                } ${index > 0 ? "mt-40 md:mt-56" : ""}`}
                data-testid={`leader-${leader.id}`}
              >
                {/* Photo */}
                <div className={`lg:col-span-3 ${index % 2 === 1 ? "lg:order-2" : ""}`}>
                  {leader.photo ? (
                    <div className={`${leader.photoSize || "w-48"} aspect-[3/4] rounded-2xl overflow-hidden`}>
                      <img 
                        src={leader.photo} 
                        alt={leader.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className={`${leader.photoSize || "w-48"} aspect-[3/4] bg-gray-100 rounded-2xl flex items-center justify-center`}>
                      <span className="text-4xl font-bold text-gray-200">
                        {leader.name.charAt(0)}
                      </span>
                    </div>
                  )}
                </div>

                {/* Info */}
                <div className={`lg:col-span-9 ${index % 2 === 1 ? "lg:order-1" : ""}`}>
                  <div className="space-y-6">
                    <div className={index > 0 ? "pt-8 lg:pt-0" : ""}>
                      <p className="text-sm text-gray-500 mb-2">{leader.title}</p>
                      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">
                        {leader.name}
                      </h2>
                      <p className="font-en text-base text-gray-500">
                        {leader.nameEn}
                      </p>
                    </div>

                    <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                      {leader.bio}
                    </p>

                    {/* Belief */}
                    <div className="pt-6 border-t border-gray-100">
                      <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-3">
                        信念
                      </p>
                      <p className="text-lg md:text-xl font-medium text-gray-900 italic">
                        "{leader.belief}"
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
